import React from "react";

export default function AppFormikTextarea(props) {
    const {
        formik,
        stFormClass,
        textareaRows,
        textareaCols,
        labelName,
        isRequired,
        placeholder,
        formikFieldName,

        hasLimit,
        chractersLimit,
        noErrorMessage,
    } = props;

    return (
        <div
            className={`st-form ${stFormClass || ""} ${formik.touched[formikFieldName] &&
                formik.errors[formikFieldName]
                ? "has-msg msg-error"
                : ""
                } ${hasLimit ? "input-container-with-text-length has-limit" : ""}`}
        >
            {labelName ? (
                <label>
                    {labelName}
                    {isRequired && <span className="required ms-1 st-fs-12">(required)</span>}
                </label>
            ) : null}
            <textarea
                type="text"
                className="form-control"
                cols={textareaCols ?? ""}
                rows={textareaRows ?? ""}
                placeholder={placeholder}
                id={formikFieldName}
                {...formik.getFieldProps(formikFieldName)}
            ></textarea>
            {
                /* form message */
                !noErrorMessage
                    ? formik.touched[formikFieldName] &&
                    formik.errors[formikFieldName] && (
                        <div className="st-form-msg position-absolute">
                            <p className="st-fs-12">
                                {formik.errors[formikFieldName]}
                            </p>
                        </div>
                    )
                    : null
            }
            {
                /* text length */
                hasLimit ? (
                    <div className="text-length">
                        <p className="">
                            {`${formik.getFieldProps(formikFieldName)?.value
                                ?.length
                                } of ${chractersLimit ?? 0} characters used`}
                        </p>
                    </div>
                ) : null
            }
        </div>
    );
}
